import { invalidateItemQueries } from '@/shared/api/invalidate-item-queries';
import { trpc } from '@/shared/api/trpc';

export const useUpdateAttentionCategory = () => {
  const utils = trpc.useUtils();
  return trpc.operations.updateAttentionCategory.useMutation({
    onSettled: () => invalidateItemQueries(utils),
  });
};
